import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';
import TooltipIcon from '../../../../Cutesies/TooltipIcon';

function Title() {
  return (
    <div className="items-center pb-5">
      <div className="font-semibold flex">
        <T kind={'More Offerings from ExecOnline'} />
        <div className="pl-4 flex items-center">
          <TooltipIcon />
        </div>
      </div>
    </div>
  );
}

export default observer(Title);
